import { BeratungsManager } from "./beratung/BeratungsManager";

export class Beratung {
    constructor(viewRoot: HTMLElement) {
        new BeratungsManager(viewRoot);
    }
}
